import { pick } from 'lodash-es';

import { ASSET } from '../../configs/constants';
import { isFinanceQV } from '../../utils';
import axios from '../../../../configs/axios';

const {
  kpi_spotlight,
  drivers,
  company_data,
  mpi_spotlight,
  pub_contribution,
} = ASSET;

// Company Assets
export const makeCompanyAssetList = (permissions) => {
  if (isFinanceQV(permissions)) {
    return [company_data, mpi_spotlight, kpi_spotlight, drivers];
  }

  return [company_data, pub_contribution, drivers];
};

export const fetchCompanyQuickview = ({ filters, asset }, params) => {
  const baseUrl = `/companies/${filters.ref_no}`;

  switch (asset) {
    case company_data:
      return Promise.allSettled([
        axios.get(`${baseUrl}/header_data.json`, { params }),
        axios.get(`${baseUrl}/status.json`),
      ]);
    case mpi_spotlight:
      return axios.get(`${baseUrl}/mpis.json`).then(({ data }) => {
        if (data?.[0]?.id) {
          return axios.get(`${baseUrl}/mpi_spotlight_data.json`);
        }

        return { data: [] };
      });
    case kpi_spotlight:
      return axios.get(`${baseUrl}/kpi_spotlight_data.json`, {
        params: {
          ...pick(filters, ['bloomberg_ticker']),
          ...params,
        },
      });
    case drivers: {
      const decoratedParams = {
        asset,
        filters: {
          base_uids: [`UC:${filters.ref_no}`],
          change_type: 'year_over_year',
          fiscal_year_end_month: filters.fiscal_year_end_month || 'Dec',
        },
      };

      return axios.post(`${baseUrl}/drivers.json`, decoratedParams, params);
    }
    case pub_contribution: {
      const requestParams = {
        params: {
          request: {
            assets: {
              company_details: {
                assets: ['publishers_performance'],
              },
            },
          },
        },
        ...params,
      };

      return axios.get(`${baseUrl}/details.json`, requestParams);
    }
    default:
      return Promise.resolve();
  }
};
